/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Collapse } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import DefaultAvatar from 'components/common/DefaultAvatar';
import IconComponent from 'components/common/IconComponent';
import { DEFAULT_FORMAT_DATE_INPUT_US, FORMAT_TIME } from 'constants/days';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import moment from 'moment';
import React, { useState } from 'react';
import { getDefaultAvatarUrl } from 'utils/utils';

import { checkUserIsInChatRoom } from '../hooks';
import AppointmentCollapseDetail from './AppointmentCollapseDetail';
import LeaveAppointmentChat from './LeaveAppointmentChat';
import { IAppointmentListInMessageTabProps } from './types';

const { Panel } = Collapse;
const AppointmentListInMessageTab: React.FC<IAppointmentListInMessageTabProps> = ({
  transaction,
  onAppointmentClick,
  selectedChatRoom,
  chatRooms,
  refetchChatRoom,
}) => {
  const { signatories } = transaction || {};
  const [collapseKeys, setCollapseKeys] = useState<Record<string, boolean>>({});
  const userId = useCurrentLoggedInUser().id;

  return (
    <Collapse ghost activeKey={Object.keys(collapseKeys)} className='transaction-message-appointments-collapse'>
      {chatRooms?.map((chatRoom, appIndex) => {
        const { appointment } = chatRoom;
        if (!appointment) return null;

        const isUserInChatRoom = checkUserIsInChatRoom(userId, chatRoom);

        const appoinmentDate = moment(appointment.date).format(DEFAULT_FORMAT_DATE_INPUT_US).toString();
        const appointmentTime = moment(appointment.date).format(FORMAT_TIME).toString();
        const signatoriesInAppointment = signatories?.filter((sig) => appointment.signatoryIds?.includes(sig.id)) || [];
        const { notary } = appointment;
        const chatRoomId = chatRoom.id || '';
        const appointmentCollapseData = [
          {
            title: 'Time',
            children: appointmentTime,
          },
          {
            title: 'Signatories',
            children: signatoriesInAppointment.reduce(
              (acc, sig, index) =>
                index === signatoriesInAppointment.length - 1
                  ? acc.concat(`${sig.firstName} ${sig.lastName}`)
                  : acc.concat(`${sig.firstName} ${sig.lastName}, `),
              '',
            ),
          },
          {
            title: 'Notary',
            children: notary ? (
              <>
                <Avatar
                  src={
                    notary?.avatar?.thumbnailPipeFrom || getDefaultAvatarUrl(`${notary.firstName} ${notary.lastName}`)
                  }
                />
                <div className='ml-2'>
                  {notary.firstName} {notary.lastName}
                </div>
              </>
            ) : (
              <div>None</div>
            ),
          },
        ];

        return (
          <Panel
            className='!rounded-none'
            header={
              <div
                className={`!p-0 conversation-card flex items-center space-between border-b border-border_color ${
                  selectedChatRoom?.id === chatRoomId ? 'active' : ''
                }`}>
                <div
                  className='p-5'
                  onClick={() => {
                    setCollapseKeys((c) => {
                      const current = { ...c };
                      if (current[chatRoomId]) {
                        delete current[chatRoomId];
                      } else {
                        current[chatRoomId] = true;
                      }
                      return current;
                    });
                  }}>
                  <IconComponent
                    className={`transition-all duration-100 ${collapseKeys[chatRoomId] ? 'rotate-90' : ''}`}
                    name='chevron-right'
                  />
                </div>
                <div
                  className='p-5 pl-0 flex-1 flex items-center'
                  onClick={(e) => {
                    e.stopPropagation();
                    onAppointmentClick?.(chatRoom);
                    if (!collapseKeys[chatRoomId]) {
                      setCollapseKeys((c) => ({ ...c, [chatRoomId]: true }));
                    }
                  }}>
                  Appointment {appoinmentDate}
                  {chatRoom?.unreadMessagesCount && checkUserIsInChatRoom(userId, chatRoom) ? (
                    <div className='ml-2'>
                      <DefaultAvatar bgColor='red'>{chatRoom.unreadMessagesCount}</DefaultAvatar>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            }
            forceRender
            showArrow={false}
            style={{ padding: 0 }}
            key={chatRoomId}>
            <div
              className={`border-b border-border_color p-5 ${appIndex === chatRooms.length - 1 ? '!border-b-0' : ''}`}>
              {appointmentCollapseData.map((appCollapseData, index) => (
                <AppointmentCollapseDetail key={index} title={appCollapseData.title}>
                  {appCollapseData.children}
                </AppointmentCollapseDetail>
              ))}
              {isUserInChatRoom && (
                <div className='mt-3'>
                  <LeaveAppointmentChat callback={refetchChatRoom} chatRoom={selectedChatRoom} />
                </div>
              )}
            </div>
          </Panel>
        );
      })}
    </Collapse>
  );
};

export default React.memo(AppointmentListInMessageTab);
